import type { ReportPointer } from "@/lib/reports";
import type { DockDetail } from "@/lib/use-right-dock";

export interface SessionBoundReportEdit {
  sessionId: string;
  pointer: ReportPointer;
  draft: string;
}

interface ReportRequestContext {
  activeReport?: ReportPointer;
  reportEditBase?: ReportPointer;
}

export function dockDetailForSession(
  detail: DockDetail | null,
  sessionId: string | undefined,
): DockDetail | null {
  if (detail?.kind !== "report") return detail;
  return detail.sessionId === sessionId ? detail : null;
}

export function reportRequestContextForSession(args: {
  sessionId: string | undefined;
  detail: DockDetail | null;
  edit: SessionBoundReportEdit | null;
}): ReportRequestContext {
  if (args.sessionId === undefined) return {};

  const editPointer = args.edit?.sessionId === args.sessionId ? args.edit.pointer : undefined;
  const detail = dockDetailForSession(args.detail, args.sessionId);
  const activePointer =
    editPointer ??
    (detail?.kind === "report"
      ? {
          report_id: detail.reportId,
          revision_number: detail.revisionNumber,
        }
      : undefined);

  return {
    ...(activePointer ? { activeReport: activePointer } : {}),
    ...(editPointer ? { reportEditBase: editPointer } : {}),
  };
}

export function composerAfterReportEditCleanup(
  input: string,
  edit: SessionBoundReportEdit,
): string {
  return input.startsWith(edit.draft) ? "" : input;
}
